import { CashDrawerTotalsDTO } from "../dto/CashDrawerTotalsDTO";
import { CashDrawerTotals } from "../models/CashDrawers/CashDrawerTotal";

export const cashDrawerTotalsMapper = (
  dto: CashDrawerTotalsDTO,
): CashDrawerTotals => {
  return new CashDrawerTotals({
    totalId: dto.totalId,
    reportDate: dto.reportDate,
    cashDrawerId: dto.cashDrawerId,
    startingCashTotalCents: dto.startingCashTotalCents,
    endingCashTotalCents: dto.endingCashTotalCents,
    cashSalesCents: dto.cashSalesCents,
    endingCheckTotalCents: dto.endingCheckTotalCents,
    checkSalesCents: dto.checkSalesCents,
    finalizedFlag: dto.finalizedFlag,
    finalizedOn: dto.finalizedOn,
    finalizedBy: dto.finalizedBy,
  });
};
